import { useEffect, useState } from 'react';

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const val = localStorage.getItem('pd_cookies');
    if (!val) setVisible(true);
  }, []);
  if (!visible) return null;
  const set = (choice) => {
    localStorage.setItem('pd_cookies', choice);
    setVisible(false);
  };
  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-[420px] bg-surface border border-pd rounded-2xl p-4 z-50 shadow-2xl"
      role="dialog"
      aria-label="Cookie preferences"
      data-testid="cookie-banner"
    >
      <p className="text-sm leading-relaxed">
        We use cookies to run the site, remember preferences and measure how it performs. Choose what you're happy with.
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button
          onClick={() => set('accept')}
          className="bg-[color:var(--pd-accent-yellow)] text-[#14251c] px-3 py-2 rounded-lg text-sm font-medium"
          data-testid="cookie-accept-button"
        >Accept</button>
        <button
          onClick={() => set('reject')}
          className="border border-pd text-[color:var(--pd-text)] px-3 py-2 rounded-lg text-sm"
          data-testid="cookie-reject-button"
        >Reject</button>
        <button
          onClick={() => set('essential')}
          className="text-muted-sage hover:text-[color:var(--pd-text)] px-3 py-2 rounded-lg text-sm"
          data-testid="cookie-manage-button"
        >Essential only</button>
      </div>
    </div>
  );
};

export default CookieBanner;
